import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./Success_Modal.css";
import Lottie from "react-lottie";
import * as animationData from "./Success_Modal.json";

const Success_Modal = ({ show, handleClose, text_msg, ...props }) => {
  const defaultOptions = {
    loop: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <Modal
      {...props}
      show={show}
      onHide={handleClose}
      centered
      className="success_modal_div"
    >
      <Modal.Body className="success_modal text-center">
        <div className="success_lottie">
          <Lottie className="me-auto lottie" options={defaultOptions} />
        </div>
        <h5>{text_msg}</h5>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal;
